import React from "react";
import AdminShell from "../admin/AdminShell";
import {
  employerNavigationSections,
  flattenEmployerNavigationSections,
} from "../../config/employerNavigation";

export default function EmployerShell({
  badge = "Experts4Europe Employer",
  shellLabel = "Hiring Control Deck",
  shellDescription = "CoreUI React bildet Shell, Layout und Arbeitsflaechen fuer operative Employer-Seiten.",
  modeLabel = "Hiring Funnel",
  liveLabel = "Employer",
  utilityHref = "/dashboard/account",
  utilityLabel = "Konto",
  topSignal = "Employer System",
  topContext = "Hiring Control Deck",
  workspaceTitle = "Experts4Europe Employer",
  workspaceNotice = "Alle Employer-Unterseiten laufen jetzt in derselben CoreUI-React-Arbeitsflaeche.",
  searchTitle = "Hiring Zugriff",
  searchDescription = "Suche nach Hiring-Bereichen, Funnel-Schritten und Employer-Werkzeugen.",
  searchPlaceholder = "Anzeige, Bewerbung, Verwaltung ...",
  searchEmptyText = "Keine passende Employer-Aktion gefunden.",
  profileLinks = [
    { href: "/dashboard/employer", label: "Hiring Deck" },
    { href: "/dashboard/stb/manage", label: "Anzeigen verwalten" },
    { href: "/dashboard/stb/applications", label: "Bewerbungen" },
    { href: "/dashboard/account", label: "Konto" },
  ],
  navSections = employerNavigationSections,
  navItems = null,
  searchItems = null,
  ...props
}) {
  const resolvedSearchItems = searchItems || flattenEmployerNavigationSections(navSections);

  return (
    <AdminShell
      badge={badge}
      shellLabel={shellLabel}
      shellDescription={shellDescription}
      modeLabel={modeLabel}
      liveLabel={liveLabel}
      utilityHref={utilityHref}
      utilityLabel={utilityLabel}
      topSignal={topSignal}
      topContext={topContext}
      workspaceTitle={workspaceTitle}
      workspaceNotice={workspaceNotice}
      searchTitle={searchTitle}
      searchDescription={searchDescription}
      searchPlaceholder={searchPlaceholder}
      searchEmptyText={searchEmptyText}
      profileLinks={profileLinks}
      navSections={navSections}
      navItems={navItems}
      searchItems={resolvedSearchItems}
      family="employer"
      {...props}
    />
  );
}
